/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetDeviceControlPointIdMapRequest = {
  agentId: string;
};

/** @internal */
export type GetDeviceControlPointIdMapRequest$Outbound = {
  agent_id: string;
};

/** @internal */
export const GetDeviceControlPointIdMapRequest$outboundSchema: z.ZodType<
  GetDeviceControlPointIdMapRequest$Outbound,
  z.ZodTypeDef,
  GetDeviceControlPointIdMapRequest
> = z.object({
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function getDeviceControlPointIdMapRequestToJSON(
  getDeviceControlPointIdMapRequest: GetDeviceControlPointIdMapRequest,
): string {
  return JSON.stringify(
    GetDeviceControlPointIdMapRequest$outboundSchema.parse(
      getDeviceControlPointIdMapRequest,
    ),
  );
}
